// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CategoriesNavigationController from "./categories_navigation_controller"
application.register("categories-navigation", CategoriesNavigationController)

import ContactFormController from "./contact_form_controller"
application.register("contact-form", ContactFormController)

import DarkModeController from "./dark_mode_controller"
application.register("dark-mode", DarkModeController)

import FaqAccordionController from "./faq_accordion_controller"
application.register("faq-accordion", FaqAccordionController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LazyBgController from "./lazy_bg_controller"
application.register("lazy-bg", LazyBgController)

import MobileNavigationController from "./mobile_navigation_controller"
application.register("mobile-navigation", MobileNavigationController)

import NewsletterController from "./newsletter_controller"
application.register("newsletter", NewsletterController)

import ReadingProgressController from "./reading_progress_controller"
application.register("reading-progress", ReadingProgressController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)
